// extracted by mini-css-extract-plugin
export default {"next":"Next_next_EiHep","ok":"Next_ok_Su0Kr"};